export default "__VITE_ASSET__6QHrkqws__"